import BlockTop from "./blocks/BlockTop";
import Waiting from "./blocks/Waiting";
import React from "react";
import ResultDay from "../../results/day/ResultDay";
import ResultNight from "../../results/night/ResultNight";
import {getDateSlash} from "../../../utility/DateUtils";
import _ from "lodash";
import Banner from "./blocks/Banner";
import DrawingBottom from "./DrawingBottom";
import DrawingBottomText from "./DrawingBottomText";
import loading from "../../../assets/images/xshome.gif";

const MidSideDrawing = (props) => {
    const {results: {list: {nextDraw}}, draw} = props;
    return (
        <td>
            <div id="right_main">
                <table width="100%">
                    <tbody>
                    <tr>
                        <td className="main">
                            <BlockTop/>
                            <div className="mainbody">
                                <div id="noidung">
                                    <h1 className="pagetitle">
                                        TRỰC TIẾP XỔ SỐ Miền Nam {getDateSlash()}
                                    </h1>
                                    <div className="box_mienuutien">
                                        <div id="hinhxstt">
                                            <div>
                                                <img src={loading} alt="loading" border="0" align="middle"/>
                                                <div id="statusbar">
                                                    <a href="/" className="running">
                                                        Đang tường thuật trực tiếp KQXS Miền Trung » Bấm Xem!...
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div id="tab_xstt">
                                        {" "}
                                        <a href="/">Miền Nam</a>{" "}
                                        <a href="/">
                                            Miền Trung
                                        </a>{" "}
                                        <a href="/">Miền Bắc &amp; Điện Toán</a>{" "}
                                    </div>

                                    {(_.isEmpty(draw) && nextDraw) && <Waiting nextDraw={nextDraw}/>}
                                    {
                                        draw?.isNight ? (
                                            <ResultNight isDraw items={draw} {...props} />
                                        ) : (
                                            <ResultDay items={draw} isDrawing={!_.isEmpty(draw)} {...props} />
                                        )
                                    }
                                </div>
                            </div>
                            <DrawingBottom/>
                            <div className="clear"/>
                            <Banner num="1"/>
                            <DrawingBottomText/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </td>
    );
};

export default MidSideDrawing;
